export const FaqData = {
  // title: "FAQ (How it works)",

  rows: [
    {
      id: 1,
      title: "Do you provide home tutors at my door step? ",
      content: `Yes, HomeShiksha provide both "Home Tutors at your doorstep" and "Online Tutors" as per 
          your need`,
    },
    {
      id: 2,
      title: " Do you also provide tutor for extracurricular activities? ",
      content: `Yes, HomeShiksha provide tutors for dancing, singing, Painting, cooking and many other co-
          curricular activities. `,
    },
    {
      id: 3,
      title: " Do you provide free demo class before we finalise with any tutor? ",
      content: `Yes, we provide free demo class. You can have demo sessions with our tutors to select the 
          best one as per your need.`,
    },
    {
      id: 4,
      title: "Do you provide female tutors for female candidates?  ",
      content: `Yes, we provide female tutors for female students.`,
    },
    {
      id: 5,
      title: "How many tutors can we try for demo classes? ",
      content: `Normally, the first tutor provided by our team would be the best one. However, if you and 
          your kid are not comfortable with the tutor then we would go ahead with a 2nd option. `,
    },
    {
      id: 6,
      title: "Can we replace a tutor after a month or two in case if we don't like the tutor? ",
      content: `Yes, obviously you can change tutor at any time, we just request parents to inform us 15days 
          prior to find the replacement. `,
    },
    {
      id: 7,
      title: "How many replacement of tutors can be Provided by HomeShiksha?",
      content: `We don't have any limitations in your tutor replacement. Whenever you want tutor needs to 
          be replaced, then Our team will help you with replacement.`,
    },
    {
      id: 8,
      title: "How soon HomeShiksha provides the Tutor once we give our tuition requirement?  ",
      content: `Our team works manually to find the best tutor as per your requirement.  
          If you need "Online tutor" then within 1-5 hours you get a tutor. 
          If you are looking for "Home Tutor at your door step" then generally it take 1-7 working 
          days to get the best tutor.`,
    },
  ],
};
